import React, { KeyboardEvent } from 'react';
import styled from 'styled-components';

export interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  bgColour?: string; // Remove in future - should use classes instead
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  label?: string;
  testId?: string;
  handleClick?: () => void;
  handleBlur?: () => void;
  handleOnKeyDown?: (e: KeyboardEvent) => void;
  innerRef?: any;
}

interface ButtonStyleProps {
  bgColour?: string;
  disabled?: boolean;
}

const StyledButton = styled.button<ButtonStyleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  min-height: 40px;
  border: 0;

  ${({ bgColour }) => bgColour && `background-color: ${bgColour};`};
  ${({ disabled }) => disabled && 'pointer-events: none;'};
`;

const Button = ({
  children,
  className,
  bgColour,
  type = 'button',
  disabled,
  label,
  handleClick,
  handleBlur,
  handleOnKeyDown,
  testId,
  innerRef,
}: ButtonProps) => (
  <StyledButton
    ref={innerRef}
    className={className ? `${className} cef-ui__button` : 'cef-ui__button'}
    type={type}
    disabled={disabled}
    onClick={handleClick}
    onBlur={handleBlur}
    onKeyDown={handleOnKeyDown}
    bgColour={bgColour}
    aria-label={label}
    data-gtm-click="true"
    data-testid={testId}>
    {children}
  </StyledButton>
);

export default Button;
